export default __webpack_public_path__ + "static/media/center-images.4b8a5b88.png";